import { gql } from '@apollo/client';

export const FETCH_PACKAGES = gql`
   query FetchAllPackages {
    fetchAllPackages {
        data {
            packages {
                package_type
                created_at
                updated_at
                package_order
                id
                name
                description
                information
            }
        }
        error {
            message
            code
            field
        }
    }
}

`;


